import { useSyncExternalStore } from 'react';
import { navigationStore } from '@bridge/navigationStore';

export function useNavigationStore() {
  return useSyncExternalStore(
    navigationStore.subscribe,
    navigationStore.getSnapshot,
    navigationStore.getSnapshot,
  );
}
